import { baseDocsLink } from "../../../utils/docs-links";

const base = `${baseDocsLink}/core-concepts/authentication`;

export const authenticationDocsLinks = {
  setup: `${base}/setup`,
};
